import script from "./EditCouponReservationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCouponReservationForm.vue?vue&type=script&setup=true&lang=js"

import "./EditCouponReservationForm.vue?vue&type=style&index=0&id=2e5c1dbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e5c1dbd"]])

export default __exports__